<template>
  <div
    class="mix-popup-single"
    :class="[size == 'small' ? 'mix-popup-single-small' : '', device.isMobile ? 'mix-popup-single-mobile' : '']"
    :id="content.key"
  >
    <div class="single-box" :class="showMoreTemplate ? 'single-more-box' : ''">
      <template v-if="!showMoreTemplate">
        <div class="single-title">{{ content.title }}</div>
        <div class="single-info">{{ content.info }}</div>
        <div class="single-btn" @click.stop="clickHandle">去体验</div>
        <popups ref="popups" :content="content"></popups>
      </template>
      <template v-else>
        <div class="single-more-title">
          <span class="back-icon" @click.stop="showMoreTemplate = false"></span>
          {{ content.moreTitle }}
        </div>
        <div class="single-more-list">
          <div v-for="(item, index) in content.content" :key="item.key">
            <div class="more-item" @click.stop="showPopupHandle(index)">
              <span>{{ item.title }}</span>
            </div>
            <popups :ref="`popups${index}`" :content="item"></popups>
          </div>
        </div>
      </template>
    </div>

  </div>
</template>
<script>
/*
基础模板组件
*/
import popups from "./popups.vue";

export default {
  name: "mixPopupIndex",
  components: {
    popups,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
    size: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {
      showMoreTemplate: false,
    }
  },
  methods: {
    clickHandle() {
      if(this.content.type === 'mix') {
        this.showMoreTemplate = true;
      }else{
        this.showPopupHandle();
      }
    },
    showPopupHandle(index) {
      if(this.content.type === 'mix') {
        let refName = 'popups' + index;
        this.$refs[refName][0].showPopupHandle();
      }else{
        this.$refs.popups.showPopupHandle();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.mix-popup-single{
  width: 100%;
  position: relative;
  overflow: hidden;

  .single-box{
    width: 100%;
    background: #fff;
    border-radius: 16rem;
    padding: 40rem 34rem 0;
    position: relative;

    .single-title{
      font-size: 22rem;
      font-weight: bold;
      line-height: 42rem;
      text-align: center;
      color: #1A1A1A;
    }

    .single-info{
      font-size: 18rem;
      line-height: 28rem;
      color: #666;
      margin-top: 20rem;
    }

    .single-btn{
      font-size: 18rem;
      line-height: 28rem;
      position: absolute;
      bottom: 37rem;
      left: 50%;
      transform: translateX(-50%);
      color: #2C8FF4;
      cursor: pointer;
      padding-right: 37rem;

      &:after{
        content: '';
        width: 26rem;
        height: 26rem;
        position: absolute;
        top: 50%;
        right: 0;
        margin-top: -13rem;
        background: url(~@/assets/images/books/bookExample/arrow-icon.png) center center no-repeat;
        background-size: contain;
      }
    }

  }

  .single-more-box{
    padding: 30rem 20rem 0;
    box-sizing: border-box;

    .single-more-title{
      font-size: 18rem;
      line-height: 28rem;
      color: #666;
      padding-left: 35rem;
      position: relative;

      .back-icon{
        width: 26rem;
        height: 26rem;
        position: absolute;
        top: 50%;
        left: 0;
        margin-top: -13rem;
        background: url(~@/assets/images/books/bookExample/arrow-back-icon.png) center center no-repeat;
        background-size: contain;
      }
    }

    .single-more-list{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 15rem;

      .more-item{
        width: 145rem;
        height: 90rem;
        background: #F2F8FD;
        border-radius: 10rem;
        margin-bottom: 6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        white-space: pre-wrap;

        span{
          text-align: center;
          font-size: 18rem;
          color: #333;
          line-height: 30rem;
        }
      }
    }
  }
}

.mix-popup-single-small{
  
  .single-box{
    width: 340rem;
    height: 280rem;
    background: #fff;
    border-radius: 16rem;
  }
}

.mix-popup-single-mobile.mix-popup-single-small{
  .single-box{
    width: 340rem;
    height: 340rem;

    .single-title{
      font-size: 28rem;
      line-height: 38rem;
    }

    .single-info{
      font-size: 24rem;
      line-height: 38rem;
      margin-top: 23rem;
    }

    .single-btn{
      font-size: 24rem;
      line-height: 34rem;
      padding-right: 37rem;

      &:after{
        content: '';
        width: 34rem;
        height: 34rem;
        margin-top: -17rem;
      }
    }

  }

  .single-more-box{
    padding: 40rem 20rem 0;

    .single-more-title{
      font-size: 24rem;
      line-height: 34rem;
      padding-left: 50rem;

      .back-icon{
        width: 34rem;
        height: 34rem;
        margin-top: -17rem;
      }
    }

    .single-more-list{
      margin-top: 28rem;

      .more-item{
        height: 100rem;
        
        span{
          font-size: 24rem;
        }
      }
    }
  }
}
</style>